import React, { useContext } from 'react';
import { IEditModifierContext, EditModifierContext } from '../../../editModifierState/editModifierContext';
import { MenuTranslationForm } from 'components/TranslationForm/MenuTranslationForm';

interface ITranslationsForm {
	isVisible: boolean;
}

const TranslationsForm: React.FC<ITranslationsForm> = ({ isVisible }) => {
	const {
		setDefaultCustomerLanguage,
		setTranslationTab,
		changeNameTranslation,
		changeDescriptionTranslation,
		selectedCustomer,
		translations,
		selectedTranslationTab,
	} = useContext<IEditModifierContext>(EditModifierContext);
	return (
		<MenuTranslationForm
			setDefaultCustomerLanguage={setDefaultCustomerLanguage}
			setTranslationTab={setTranslationTab}
			changeNameTranslation={changeNameTranslation}
			changeDescriptionTranslation={changeDescriptionTranslation}
			isVisible={isVisible}
			IDSelectedCustomer={selectedCustomer}
			translations={translations}
			selectedTranslationTab={selectedTranslationTab}
		/>
	);
};

export default TranslationsForm;
